import React, { useEffect, useState } from 'react'
import { fetchPackageResult } from '../utils/services'
import { useModifySearch } from './useModifySearch';
import { assembleCountry } from '../utils/filter';
import { useSelector } from 'react-redux';

const useFetchPackageResult = () => {
    const [packageResult, setPackageResult] = useState([])
    const { setCountryNames } = useModifySearch();
    const [isLoading, setLoading] = useState(true)
    const culture = useSelector((state) => state.culture.currentCulture);
    const currency = useSelector((state) => state.currencyDetails);

    useEffect(() => {
        (async () => {
            if (!currency.loading) {
                let packageResult = await fetchPackageResult(culture, currency.currentCurrency)
                if (packageResult) {
                    setPackageResult(packageResult)
                    setCountryNames(assembleCountry(packageResult));
                    setLoading(false)
                }
            }
        })()
    }, [currency])
    return { packageResult,isLoading }
}

export default useFetchPackageResult